import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';

import { useContacts } from '@hooks/API/Contact/UseContactsList';

import GlobalSearch from '@components/_LayoutComponents/Header/GlobalSearch/GlobalSearch';

import StyleVariables from '@components/Gui/StyleVariables';

const GlobalSearchWrapperAccounting = () => {
    //const { data: accountingContacts, isFetching: loadingAccountingContacts } = useAccountingContactsList();
    const navigate = useNavigate();
    const { data, isFetching } = useContacts();

    const getItemSearchGroup = (subtype) => {
        return subtype === 4
            ? 'models'
            : subtype === 5
              ? 'scouting'
              : subtype === 1
                ? 'clients'
                : subtype === 2
                  ? 'agencies'
                  : 'services';
    };

    const sources = useMemo(() => {
        if (isFetching) {
            return [];
        }

        const source = data
            ? data.map((item) => ({
                  ID: item.ID,
                  cover: null,
                  subtype: item.ST,
                  showValue: `${item.N.trim()} ${item.S ? item.S.trim() : ''}`,
                  searchValue: item._normalizedFullName,
                  secondLine: null,
                  searchGroup: getItemSearchGroup(item.ST),
              }))
            : [];
        return source;
    }, [data, isFetching]);

    const onSearchContact = (contactInfo) => {
        if (contactInfo.type === 'model') {
            navigate(`/accounting/model/${contactInfo.ID}`);
        } else {
            navigate(`/accounting/customer/${contactInfo.ID}`);
        }
    };

    if (isFetching) {
        return <BeatLoader size={8} color={StyleVariables.PrimaryColor} />;
    }
    return <GlobalSearch sources={sources} onSearchContact={onSearchContact} />;
};

export default GlobalSearchWrapperAccounting;
